import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {Router} from "@angular/router";
import {NzMessageService} from "ng-zorro-antd/message";
import {lastValueFrom} from "rxjs";
import {PTPMetaDataMapDto, PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-ptp-metadata-map",
    templateUrl: "./ptp-metadata-map.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PTPMetaDataMapComponent implements OnInit {
    constructor(
        private readonly api: PerFormaAPIService,
        private router: Router,
        private message: NzMessageService
    ) {}

    loading = true;
    maps: PTPMetaDataMapDto[] = [];

    async ngOnInit() {
        await this.getData();
    }

    getData = async () => {
        this.loading = true;
        try {
            this.maps = await lastValueFrom(this.api.getApiConfigurePtpMetadataMaps());
        } catch (e) {
            this.message.error("Failed to fetch metadata maps");
            console.log(e);
        } finally {
            this.loading = false;
        }
    };

    addMap = () => {
        this.router.navigateByUrl("/configure/ptpmetadatamapcreate");
    };

    editMap = (id: number) => {
        this.router.navigate(["/configure/ptpmetadatamapedit"], {queryParams: {id}});
    };

    deleteMap = async (id: number) => {
        this.loading = true;
        try {
            await lastValueFrom(this.api.deleteApiConfigurePtpMetadataMapsId(id));
            this.message.success("Metadata map deleted");
            await this.getData();
        } catch (e) {
            this.message.error("Failed to delete metadata map");
            console.log(e);
            this.loading = false;
        }
    };
}
